// src/Pages/ServicesPage.js
import React from 'react';

const ServicesPage = ({ setCurrentPage }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-2xl p-8 md:p-12 border border-gray-100">
        <h2 className="text-4xl font-extrabold text-gray-900 text-center mb-10 drop-shadow-sm">Our Comprehensive Services</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Service Card 1: Remote Manpower */}
          <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-t-4 border-blue-500 group">
          <div class="img-box"><img alt="Custom Software Development" src="images/s3.png" /></div>
            <h3 className="text-2xl font-bold text-blue-700 mb-4 group-hover:text-blue-800 transition-colors duration-300">Remote Manpower Solutions</h3>
            <p className="text-gray-700 mb-4">
              Access top-tier talent for your projects without the overhead. We provide dedicated and shared manpower tailored to your specific needs.
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Delphi Developers</li>
              <li>C# Specialists</li>
              <li>React Developers</li>
              <li>WordPress Experts</li>
              <li>And many more technologies...</li>
            </ul>
          </div>

          {/* Service Card 2: Custom Application Development */}
          <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-t-4 border-green-500 group">
            <div class="img-box"><img alt="Web Development" src="images/s1.png" /></div>
            <h3 className="text-2xl font-bold text-green-700 mb-4 group-hover:text-green-800 transition-colors duration-300">Custom Application Development</h3>
            <p className="text-gray-700 mb-4">
              From concept to deployment, we build robust, scalable, and intuitive applications designed to meet your unique business challenges.
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Web Applications (SaaS, E-commerce, Portals)</li>
              <li>Desktop Applications (Windows, macOS, Linux)</li>
              <li>Mobile Applications (iOS, Android, Cross-platform)</li>
            </ul>
          </div>

          {/* Service Card 3: Website Designing */}
          <div className="bg-white rounded-xl shadow-lg p-6 transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border-t-4 border-purple-500 group">
          <div class="img-box"><img alt="E-commerce Solutions" src="images/s2.png" /></div>
            <h3 className="text-2xl font-bold text-purple-700 mb-4 group-hover:text-purple-800 transition-colors duration-300">Professional Website Designing</h3>
            <p className="text-gray-700 mb-4">
              Create a powerful online presence with stunning, user-friendly, and highly functional websites that convert visitors into customers.
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Responsive Web Design</li>
              <li>E-commerce Website Development</li>
              <li>CMS Integration (WordPress, etc.)</li>
              <li>UI/UX Design & Prototyping</li>
            </ul>
          </div>
        </div>
        <div className="text-center mt-12">
          <button
            onClick={() => setCurrentPage('contact')}
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-xl border-2 border-indigo-600 hover:border-indigo-800"
          >
            Get a Free Consultation
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServicesPage;

